import * as Constants from '../../../constants';

import { faClose, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Formik } from "formik";
import { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import * as Yup from "yup";

export default function LicenseFormModal({ show, onHide, onSave, license }) {
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [applications, setApplications] = useState([]);
    const [licenseTypes, setLicenceTypes] = useState([]);
    const [statusTypes, setStatusTypes] = useState([]);

    console.warn(license)

    const validationSchema = Yup.object({

        fgk_user: Yup.string()
            .notOneOf(["0"], "Selecione o licença"),

        fgk_application: Yup.string()
            .notOneOf(["0"], "Selecione a aplicação"),

        fgk_license_type: Yup.string()
            .notOneOf(["0"], "Selecione o tipo"),

        fgk_license_status: Yup.string()
            .notOneOf(["0"], "Selecione o status"),

        device: Yup.string()
            .trim()
            .required("Informe o dispositivo"),

        // secret: Yup.string()
        //     .trim()
        //     .min(10, "Secret muito curto")
        //     .required("Informe o secret"),

        expiration: Yup.date()
            .required("Informe a data de expiração")

    });

    const initialValues = {
        fgk_user: license?.fgk_user || "0",
        fgk_application: license?.fgk_application || "0",
        device: license?.device || "",
        fgk_license_type: license?.fgk_license_type || "0",
        secret: license?.secret || "",
        fgk_license_status: license?.fgk_license_status || "0",
        expiration: license?.expiration || ""
    };

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setIsLoading(true);
                const token = localStorage.getItem("token");

                const headers = {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                };

                const [
                    usersRes,
                    applicationsRes,
                    licenseTypesRes,
                    statusTypesRes
                ] = await Promise.all([

                    fetch(Constants.USERS_LIST, { signal, headers }),
                    fetch(Constants.APPLICATIONS_LIST, { signal, headers }),
                    fetch(Constants.LICENSE_TYPES_LIST, { signal, headers }),
                    fetch(Constants.LICENSE_STATUS_LIST, { signal, headers })

                ]);

                const usersJson = await usersRes.json();
                const applicationsJson = await applicationsRes.json();
                const licenseTypesJson = await licenseTypesRes.json();
                const statusTypesJson = await statusTypesRes.json();

                if (usersJson.status === "success")
                    setUsers(usersJson.data);

                if (applicationsJson.status === "success")
                    setApplications(applicationsJson.data);

                if (licenseTypesJson.status === "success")
                    setLicenceTypes(licenseTypesJson.data);

                if (statusTypesJson.status === "success")
                    setStatusTypes(statusTypesJson.data);
            } catch (error) {
                if (error.name === "AbortError") return;
                console.error("Erro:", error);
            } finally {
                setIsLoading(false);
            }

        };

        fetchData();

        return () => controller.abort();

    }, []);

    return (

        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {

                const data = license
                    ? { ...values, id: license.id }
                    : values;

                onSave(data);

                resetForm();
                onHide();

            }}
        >

            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit
            }) => (

                <Modal show={show} onHide={onHide} centered>

                    <Modal.Header closeButton className="bg-light">
                        <Modal.Title>
                            {license ? "Editar Licença" : "Cadastrar Licença"}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <Form noValidate>

                            {/* Licença */}

                            <Form.Group className="mb-3">
                                <Form.Label>Licença</Form.Label>

                                <Form.Select
                                    name="fgk_user"
                                    value={values.fgk_user}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.fgk_user && !!errors.fgk_user}
                                >

                                    <option value="0">Selecione</option>

                                    {users.map(user => (
                                        <option key={user.id} value={user.id}>
                                            {user.name}
                                        </option>
                                    ))}

                                </Form.Select>

                                <Form.Control.Feedback type="invalid">
                                    {errors.fgk_user}
                                </Form.Control.Feedback>

                            </Form.Group>


                            {/* Aplicação */}

                            <Form.Group className="mb-3">

                                <Form.Label>Aplicação</Form.Label>

                                <Form.Select
                                    name="fgk_application"
                                    value={values.fgk_application}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.fgk_application && !!errors.fgk_application}
                                >

                                    <option value="0">Selecione</option>

                                    {applications.map(app => (
                                        <option key={app.id} value={app.id}>
                                            {app.title}
                                        </option>
                                    ))}

                                </Form.Select>

                                <Form.Control.Feedback type="invalid">
                                    {errors.fgk_application}
                                </Form.Control.Feedback>

                            </Form.Group>


                            {/* Tipo */}

                            <Form.Group className="mb-3">

                                <Form.Label>Tipo de Licença</Form.Label>

                                <Form.Select
                                    name="fgk_license_type"
                                    value={values.fgk_license_type}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.fgk_license_type && !!errors.fgk_license_type}
                                >

                                    <option value="0">Selecione</option>

                                    {licenseTypes.map(type => (
                                        <option key={type.id} value={type.id}>
                                            {type.title}
                                        </option>
                                    ))}

                                </Form.Select>

                                <Form.Control.Feedback type="invalid">
                                    {errors.fgk_license_type}
                                </Form.Control.Feedback>

                            </Form.Group>


                            {/* Status */}

                            <Form.Group className="mb-3">

                                <Form.Label>Status</Form.Label>

                                <Form.Select
                                    name="fgk_license_status"
                                    value={values.fgk_license_status}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.fgk_license_status && !!errors.fgk_license_status}
                                >

                                    <option value="0">Selecione</option>

                                    {statusTypes.map(type => (
                                        <option key={type.id} value={type.id}>
                                            {type.title}
                                        </option>
                                    ))}

                                </Form.Select>

                                <Form.Control.Feedback type="invalid">
                                    {errors.fgk_license_status}
                                </Form.Control.Feedback>

                            </Form.Group>


                            {/* Device */}

                            <Form.Group className="mb-3">

                                <Form.Label>Dispositivo</Form.Label>

                                <Form.Control
                                    name="device"
                                    value={values.device}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.device && !!errors.device}
                                />

                                <Form.Control.Feedback type="invalid">
                                    {errors.device}
                                </Form.Control.Feedback>

                            </Form.Group>


                            {/* Secret */}

                            {/* <Form.Group className="mb-3">

                                <Form.Label>Secret</Form.Label>

                                <div className="d-flex gap-2">

                                    <Form.Control
                                        name="secret"
                                        value={values.secret}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        isInvalid={touched.secret && !!errors.secret}
                                    />

                                    <Button
                                        variant="warning"
                                        onClick={() => {
                                            const newSecret = generateSecret();
                                            values.secret = newSecret;
                                        }}
                                    >
                                        Gerar
                                    </Button>

                                </div>

                                <Form.Control.Feedback type="invalid">
                                    {errors.secret}
                                </Form.Control.Feedback>

                            </Form.Group> */}


                            {/* Expiration */}

                            <Form.Group>

                                <Form.Label>Data de Expiração</Form.Label>

                                <Form.Control
                                    type="date"
                                    name="expiration"
                                    value={values.expiration ? values.expiration.split(' ')[0] : ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.expiration && !!errors.expiration}
                                />

                                <Form.Control.Feedback type="invalid">
                                    {errors.expiration}
                                </Form.Control.Feedback>

                            </Form.Group>

                        </Form>

                    </Modal.Body>


                    <Modal.Footer>

                        <Button variant="outline-secondary" onClick={onHide}>
                            <FontAwesomeIcon icon={faClose} /> Cancelar
                        </Button>

                        <Button variant="primary" onClick={handleSubmit}>
                            <FontAwesomeIcon icon={faFloppyDisk} /> Salvar
                        </Button>

                    </Modal.Footer>

                </Modal>

            )}

        </Formik>

    );

}